<div [formGroup]="form" class="step-form">

  <!-- ── Action type ── -->
  <div class="section-label">
    <mat-icon class="section-icon">cleaning_services</mat-icon>
    <span>{{ stepLabel }} — choose an action</span>
  </div>

  <div class="action-tile-grid">
    <div
      *ngFor="let tile of actionTiles"
      class="action-tile"
      [class.action-tile--selected]="selectedAction === tile.value"
      [class.action-tile--danger]="tile.value === 'Destroy' && selectedAction === 'Destroy'"
      (click)="selectAction(tile.value)"
      (keyup.enter)="selectAction(tile.value)"
      tabindex="0"
      role="button"
      [attr.aria-pressed]="selectedAction === tile.value"
      [attr.aria-label]="tile.label">
      <mat-icon class="tile-icon">{{ tile.icon }}</mat-icon>
      <div class="tile-content">
        <strong>{{ tile.label }}</strong>
        <p class="tile-desc">{{ tile.description }}</p>
      </div>
    </div>
  </div>

  <!-- ── Grace period — Daily (minutes only, step=5, range 5–360) ── -->
  <ng-container *ngIf="selectedAction !== 'DoNothing' && isDaily">
    <div class="section-label">
      <mat-icon class="section-icon">timer</mat-icon>
      <span>Grace period before action</span>
    </div>
    <div class="grace-period-row">
      <mat-form-field appearance="outline" class="grace-value-field">
        <mat-label>Minutes (5 – 360)</mat-label>
        <input matInput type="number" formControlName="gracePeriodValue"
               min="5" max="360" step="5" placeholder="e.g. 60">
        <mat-hint>Maximum 6 hours (360 min). Ensures no overlap with the class-end policy.</mat-hint>
        <mat-error *ngIf="form.hasError('gracePeriodValueRequired')">
          Duration is required and must be between 5 and 360 minutes.
        </mat-error>
      </mat-form-field>
    </div>
  </ng-container>

  <!-- ── Grace period — Class End (hours / days only) ── -->
  <ng-container *ngIf="selectedAction !== 'DoNothing' && !isDaily">
    <div class="section-label">
      <mat-icon class="section-icon">timer</mat-icon>
      <span>Grace period before action</span>
    </div>
    <div class="class-end-hint">
      <mat-icon class="hint-icon">info_outline</mat-icon>
      <span>On the last session day, the daily cleanup policy is skipped — only this class-end policy applies.</span>
    </div>
    <div class="grace-period-row">
      <mat-form-field appearance="outline" class="grace-value-field">
        <mat-label>Duration</mat-label>
        <input matInput type="number" formControlName="gracePeriodValue" min="1" placeholder="e.g. 1">
        <mat-error *ngIf="form.hasError('gracePeriodValueRequired')">
          Duration is required and must be at least 1.
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="grace-unit-field">
        <mat-label>Unit</mat-label>
        <mat-select formControlName="gracePeriodUnit">
          <mat-option *ngFor="let unit of classEndGracePeriodUnits" [value]="unit">{{ unit }}</mat-option>
        </mat-select>
        <mat-error *ngIf="form.hasError('gracePeriodUnitRequired')">
          Unit is required.
        </mat-error>
      </mat-form-field>
    </div>
  </ng-container>

  <!-- ── Destroy scope ── -->
  <ng-container *ngIf="selectedAction === 'Destroy'">
    <div class="section-label">
      <mat-icon class="section-icon">delete_forever</mat-icon>
      <span>Destruction scope</span>
    </div>
    <div class="scope-tile-row">
      <div
        *ngFor="let scope of destroyScopeTiles"
        class="scope-tile"
        [class.scope-tile--selected]="form.get('destroyScope')?.value === scope.value"
        (click)="selectDestroyScope(scope.value)"
        (keyup.enter)="selectDestroyScope(scope.value)"
        tabindex="0"
        role="button"
        [attr.aria-pressed]="form.get('destroyScope')?.value === scope.value">
        <strong>{{ scope.label }}</strong>
        <p class="tile-desc">{{ scope.description }}</p>
      </div>
    </div>
    <mat-error *ngIf="form.hasError('destroyScopeRequired')" class="scope-error">
      Please select a destruction scope.
    </mat-error>
  </ng-container>

</div>
